import React from "react";
import { withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from "prop-types";
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import TextField from '@material-ui/core/TextField';
import RouterIcon from '@material-ui/icons/Router';
import ReloadIcon from '@material-ui/icons/Replay';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import AppartmentIcon from '@material-ui/icons/Apartment';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PlaceIcon from '@material-ui/icons/PlaceOutlined';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import * as helper from "../common/helper";
import SelectTable from './SelectTable';
import * as i18n from "../common/i18n";
import * as graphql from '../common/graphql';
import gql from 'graphql-tag';
import Message from "./Message";
import Grid from '@material-ui/core/Grid';
import "moment/locale/de";


moment.locale("de");

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: 200,
    },
});


class LeaseWizard extends React.Component {
    constructor(props) {

        super(props);

        this.state = {
            message: null,
            activeStep: 0,
            lease: null,
            device: null,
            deviceDetails: {},
            tenant: null,
            tenantDetails: {},
            building: null,
            buildingDetails: {},
            parcel: null,
            parcelDetails: {},
            tap: null,
            tapDetails: {},
            status: "RUNNING",
            notes: null,
            statusDetails: i18n.get("leases.status.RUNNING"),
            starts: null,
            ends: null,
            steps: this.getSteps(),
            details: null,
            hideAfter: 3000,
            variant: "info",
            search: "",
        };
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    onAddDevice = (data) => {
        this.setState({
            device: data.uuid,
            deviceDetails: data
        });
    }

    onDeleteDevice = (data) => {
        this.setState({
            device: null,
            deviceDetails: {}
        });
    }

    onAddTenant = (data) => {
        this.setState({
            tenant: data.id,
            tenantDetails: data
        });
    }

    onDeleteTenant = (data) => {
        this.setState({
            tenant: null,
            tenantDetails: {}
        });
    }

    onAddBuilding = (data) => {
        this.setState({
            building: data.id,
            buildingDetails: data
        });
    }

    onDeleteBuilding = (data) => {
        this.setState({
            building: null,
            buildingDetails: {}
        });
    }

    onAddParcel = (data) => {
        this.setState({
            parcel: data.id,
            parcelDetails: data
        });
    }

    onDeleteParcel = (data) => {
        this.setState({
            parcel: null,
            parcelDetails: data
        });
    }

    onAddTap = (data) => {
        this.setState({
            tap: data.id,
            tapDetails: data
        });
    }

    onDeleteTap = (data) => {
        this.setState({
            tap: null,
            tapDetails: {}
        });
    }

    onSetStatus = (event) => {
        switch (event.target.value) {
            case "RUNNING":
                this.setState({
                    status: "RUNNING",
                    statusDetails: i18n.get("leases.status.RUNNING")
                });
                break;
            case "PENDING":
                this.setState({
                    status: "PENDING",
                    statusDetails: i18n.get("leases.status.PENDING")
                });
                break;
            case "DONE":
                this.setState({
                    status: "DONE",
                    statusDetails: i18n.get("leases.status.DONE")
                });
                break;
        }
    }

    onClose = () => {
        this.props.onCancel();
        this.reset();
    }

    onPrevious = () => {
        const activeStep = this.state.activeStep - 1;
        this.setState({ activeStep: activeStep })
    }

    onNext = async () => {
        const activeStep = this.state.activeStep + 1;
        this.setState({ activeStep: activeStep })
    }

    nextPossible = () => {
        switch (this.state.activeStep) {
            case 0:
                return this.state.device !== null
            case 1:
                return this.state.tenant !== null
            case 2:
                return this.state.building !== null
            case 3:
                return this.state.parcel !== null
            case 4:
                return this.state.tap !== null

            default:
                return true;
        }
    }

    onSave = () => {
        this.props.onSave(
            {
                starts: this.state.starts,
                ends: this.state.ends,
                device: this.state.device,
                deviceDetails: this.state.deviceDetails,
                tenant: this.state.tenant,
                building: this.state.building,
                parcel: this.state.parcel,
                tap: this.state.tap,
                status: this.state.status,
                notes: this.state.notes,
                address: `${this.state.buildingDetails.street}, ${this.state.parcelDetails.name}, ${this.state.buildingDetails.zipCode} ${this.state.buildingDetails.place}`
            }
        );
        this.onClose();
    }

    reset = () => {
        this.setState(
            {
                message: null,
                activeStep: 0,
                lease: null,
                device: null,
                deviceDetails: {},
                tenant: null,
                tenantDetails: {},
                building: null,
                buildingDetails: {},
                parcel: null,
                parcelDetails: {},
                tap: null,
                tapDetails: {},
                status: "RUNNING",
                notes: null,
                statusDetails: i18n.get("leases.status.RUNNING"),
                starts: null,
                ends: null,
                steps: this.getSteps(),
                details: null,
                hideAfter: 3000,
                variant: "info",
                search: "",
            }
        )
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    getSteps = () => {
        return [i18n.get("leaseWizard.step.0"), i18n.get("leaseWizard.step.1"), i18n.get("leaseWizard.step.2"), i18n.get("leaseWizard.step.3"), i18n.get("leaseWizard.step.4"), i18n.get("leaseWizard.step.5"), i18n.get("leaseWizard.step.6"), i18n.get("leaseWizard.step.7"), i18n.get("leaseWizard.step.8")];
    }

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return this.selectDevice();
            case 1:
                return this.selectTenant();
            case 2:
                return this.selectBuilding();
            case 3:
                return this.selectParcel();
            case 4:
                return this.selectTap();
            case 5:
                return this.setStatus();
            case 6:
                return this.setDuration();
            case 7:
                return this.getNotes();
            case 8:
                return this.showSummary();
            default:
                return 'Error';
        }
    }

    showSummary = () => {

        const data = [
            { label: i18n.get("leaseWizard.summary.device"), value: `${this.state.deviceDetails.uuid} (${this.state.deviceDetails.imei})` },
            { label: i18n.get("leaseWizard.summary.tenant"), value: `${this.state.tenantDetails.company} (${this.state.tenantDetails.id})` },
            { label: i18n.get("leaseWizard.summary.building"), value: `${this.state.buildingDetails.street}` },
            { label: i18n.get("leaseWizard.summary.parcel"), value: `${this.state.parcelDetails.name}` },
            { label: i18n.get("leaseWizard.summary.status"), value: this.state.statusDetails },
            { label: i18n.get("leaseWizard.summary.tap"), value: `${this.state.tapDetails.name}, ${this.state.tapDetails.valve}` },
            { label: i18n.get("leaseWizard.summary.notes"), value: this.state.notes ? this.state.notes : '-' },
            { label: i18n.get("leaseWizard.summary.duration"), value: `Vom ${moment(this.state.starts).format("DD.MM.YYYY")} bis ${moment(this.state.ends).format("DD.MM.YYYY")}` },
        ]

        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="md">

                    <Grid
                        container={true}
                        spacing={1}
                        justify={'center'}
                    >

                        {data && data.map(d =>
                            <React.Fragment>
                                <Grid item xs={12} lg={6}>
                                    <b>{d.label}</b>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    {d.value}
                                </Grid>
                            </React.Fragment>
                        )}

                    </Grid>

                </Container>
            </React.Fragment>

        )
    }

    mapField(column) {
        return column;
    }

    setDuration = () => {
        if (this.state.starts === null) {
            this.setState({ starts: moment().format('YYYY-MM-DD') })
        }
        if (this.state.ends === null) {
            this.setState({ ends: moment().add(6, 'month').format('YYYY-MM-DD') })
        }

        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"de"}>

                        <DatePicker
                            label={i18n.get("leaseWizard.starts.label")}
                            inputVariant="outlined"
                            value={this.state.starts}
                            ampm={false}
                            cancelLabel={i18n.get("dateTimePicker.cancelLabel")}
                            okLabel={i18n.get("dateTimePicker.okLabel")}
                            showTodayButton={true}
                            format={"[vom] DD.MM.YYYY"}
                            todayLabel={i18n.get("dateTimePicker.todayLabel")}
                            onChange={(date) => { this.setState({ starts: date }) }}
                        />

                        <DatePicker
                            style={{ marginTop: 32 }}
                            label={i18n.get("leaseWizard.ends.label")}
                            inputVariant="outlined"
                            value={this.state.ends}
                            minDate={this.state.starts !== null ? this.state.starts : moment()}
                            strictCompareDates={true}
                            ampm={false}
                            cancelLabel={i18n.get("dateTimePicker.cancelLabel")}
                            okLabel={i18n.get("dateTimePicker.okLabel")}
                            showTodayButton={true}
                            format={"[bis zum] DD.MM.YYYY"}
                            todayLabel={i18n.get("dateTimePicker.todayLabel")}
                            onChange={(date) => { this.setState({ ends: date }) }}
                            minDateMessage={i18n.get("dateTimePicker.minDateMessage")}
                        />
                    </MuiPickersUtilsProvider>
                </Container>


            </React.Fragment>
        )
    }

    selectDevice = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Gerät ausgewählt. Wählen Sie ein Gerät aus der Liste aus"}
                        title1={"Gerät"}
                        title2={"Vorhandene Geräte"}
                        columns={[
                            {
                                title: "Geräte-ID",
                                hidden: false,
                                filtering: true,
                                field: "uuid"
                            },
                            {
                                title: "Geräte-IMEI",
                                hidden: false,
                                filtering: true,
                                field: "imei"
                            },

                        ]}
                        chipIcon={<RouterIcon />}
                        chipLabel={() => { return this.state.device }}
                        selected={this.state.device}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    query["filters"].push({ column: { field: "status" }, operator: '=', value: "STOCKED" })
                                    const orderBy = helper.orderByString(query, this.mapField, "uuid", true);
                                    const where = helper.whereString(query["filters"], this.mapField, ["uuid"]);
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            devices(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Device {
                                                    id
                                                    uuid
                                                    imei
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });


                                    resolve({
                                        page: query.page,
                                        data: result.data.devices.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    uuid: element.uuid,
                                                    imei: element.imei
                                                };
                                            }),
                                        totalCount: result.data.devices.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddDevice}
                        onDelete={this.onDeleteDevice}
                        onCancel={this.onClose}
                    />
                </Container>
            </React.Fragment>
        )
    }

    selectTenant = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Mieter ausgewählt. Wählen Sie einen Mieter aus der Liste aus"}
                        title1={"Mieter"}
                        title2={"Vorhandene Mieter"}
                        columns={[
                            {
                                title: "Kunde",
                                hidden: false,
                                filtering: true,
                                field: "company"
                            },
                            {
                                title: "Kundennummer",
                                hidden: false,
                                filtering: false,
                                field: "id"
                            },


                        ]}
                        deleteAllLabel="Mieter entfernen"
                        chipIcon={<ContactMailIcon />}
                        chipLabel={() => { return `${this.state.tenantDetails.company} (${this.state.tenantDetails.id})` }}
                        selected={this.state.tenant}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    const orderBy = '[{column: "company" direction: ASC}]'
                                    const where = helper.whereString(query["filters"], this.mapField);
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            tenants(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Tenant {
                                                    id
                                                    company
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });


                                    resolve({
                                        page: query.page,
                                        data: result.data.tenants.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    company: element.company,
                                                };
                                            }),
                                        totalCount: result.data.tenants.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddTenant}
                        onDelete={this.onDeleteTenant}
                    />
                </Container>
            </React.Fragment>
        )
    }

    selectBuilding = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Gebäude ausgewählt. Wählen Sie ein Gebäude aus der Liste aus"}
                        title1={"Gebäude"}
                        title2={"Vorhandene Gebäude"}
                        columns={[
                            {
                                title: "Adresse",
                                hidden: false,
                                filtering: true,
                                field: "street",
                                render: rowData => { return rowData ? `${rowData.street ? rowData.street : ''}, ${rowData.zipCode ? rowData.zipCode : ''} ${rowData.place ? rowData.place : ''}` : null },
                            },

                        ]}
                        chipIcon={<AppartmentIcon />}
                        chipLabel={() => { return `${this.state.buildingDetails.street}` }}
                        selected={this.state.building}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {

                                    query["filters"].push({ column: { field: "tenant" }, operator: '=', value: this.state.tenant })
                                    const where = helper.whereString(query["filters"], this.mapField, ["tenant"]);
                                    const orderBy = '[{column: "street", direction: ASC}]'
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                        query {
                                            buildings(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Building {
                                                    id
                                                    street
                                                    zipCode
                                                    place
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.buildings.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    street: element.street,
                                                    zipCode: element.zipCode,
                                                    place: element.place
                                                };
                                            }),
                                        totalCount: result.data.buildings.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={
                            []
                        }
                        onAdd={this.onAddBuilding}
                        onDelete={this.onDeleteBuilding}
                    />
                </Container>
            </React.Fragment>
        )
    }

    selectParcel = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Keine Wohnung ausgewählt. Wählen Sie eine Wohnung aus der Liste aus"}
                        title1={"Wohnung"}
                        title2={"Vorhandene Wohnungen"}
                        columns={[
                            {
                                title: "Etage",
                                hidden: false,
                                filtering: true,
                                field: "name"
                            },

                        ]}
                        chipIcon={<MeetingRoomIcon />}
                        chipLabel={() => { return this.state.parcelDetails.name }}
                        selected={this.state.parcel}
                        filtering={true}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    query["filters"].push({ column: { field: "building" }, operator: '=', value: this.state.building })
                                    const orderBy = '[{column: "name" direction: ASC}]'

                                    const where = helper.whereString(query["filters"], this.mapField, ["building"]);
                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                            query {
                                                parcels(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Parcel {
                                                    id
                                                    name
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.parcels.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    name: element.name,
                                                };
                                            }),
                                        totalCount: result.data.parcels.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        actions={[]}
                        onAdd={this.onAddParcel}
                        onDelete={this.onDeleteParcel}
                    />
                </Container>
            </React.Fragment>
        )
    }

    selectTap = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <SelectTable
                        noneText={"Kein Anschluss ausgewählt. Wählen Sie einen Anschluss aus der Liste aus"}
                        title1={"Anschluss"}
                        title2={"Vorhandene Anschlüsse"}
                        columns={[
                            {
                                title: "Zimmer",
                                hidden: false,
                                filtering: true,
                                field: "name"
                            },
                            {
                                title: "Anschluss",
                                hidden: false,
                                filtering: false,
                                field: "valve"
                            },
                            {
                                title: "Armatur",
                                hidden: false,
                                filtering: false,
                                field: "faucet"
                            },

                        ]}
                        chipIcon={<PlaceIcon />}
                        chipLabel={() => { return `${this.state.tapDetails.valve} (${this.state.tapDetails.name})` }}
                        selected={this.state.tap}
                        filtering={false}
                        data={query =>
                            new Promise(async (resolve, reject) => {

                                try {
                                    query["filters"].push({ column: { field: "parcel" }, operator: '=', value: this.state.parcel })
                                    let orderBy = '[{column: "name", direction: ASC}]'
                                    const where = helper.whereString(query["filters"], this.mapField, ["parcel", "id"]);

                                    const result = await graphql.clientWithToken(this.props.accessToken).query({
                                        query: gql`
                                            query {
                                                taps(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                                totalCount
                                                elements {
                                                ... on Tap {
                                                    id
                                                    name
                                                    faucet
                                                    valve
                                                }
                                            }
                                        }
                                    }
                                    `,
                                        fetchPolicy: "no-cache"
                                    });

                                    resolve({
                                        page: query.page,
                                        data: result.data.taps.elements.map(
                                            (element) => {
                                                return {
                                                    id: element.id,
                                                    faucet: element.faucet,
                                                    valve: element.valve,
                                                    name: element.name,
                                                };
                                            }),
                                        totalCount: result.data.taps.totalCount
                                    });
                                } catch (error) {
                                    this.showMessage(error.message, "error");
                                    reject(error);
                                }
                            })
                        }
                        editable={{
                            isEditable: true,
                            onRowAdd: newData =>
                                new Promise(async (resolve, reject) => {
                                    try {
                                        newData["parcel"] = this.state.parcel
                                        newData["building"] = this.state.building
                                        newData["tenant"] = this.state.tenant
                                        const input = newData

                                        const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                            variables: {
                                                "input": input,
                                            },
                                            mutation: gql`
                                            mutation addTap($input: TapInput!) {
                                                addTap(input: $input) {
                                                    id
                                                }
                                            }
                                        `,
                                        });

                                        this.showMessage(i18n.get("taps.message.onAdd.success"), "success")

                                        resolve();
                                    } catch (error) {
                                        this.showMessage(i18n.get("taps.message.onAdd.error"), "error", error.message);
                                        reject(error);
                                    }
                                }),
                        }}
                        actions={[]}
                        onAdd={this.onAddTap}
                        onDelete={this.onDeleteTap}
                    />
                </Container>
            </React.Fragment>
        )
    }

    setStatus = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg" >
                    <FormControl variant="outlined" align="center" >
                        <Select
                            style={{ width: "50%", align: "center", alignItems: "center" }}
                            defaultValue={"RUNNING"}
                            onChange={this.onSetStatus}
                        >
                            <MenuItem value="RUNNING" align="center" > {i18n.get("leases.status.RUNNING")} </MenuItem>
                            <MenuItem value="PENDING" align="center" > {i18n.get("leases.status.PENDING")} </MenuItem>
                            <MenuItem value="DONE" align="center" > {i18n.get("leases.status.DONE")} </MenuItem>
                        </Select>
                    </FormControl>
                </Container>
            </React.Fragment>
        )
    }

    getNotes = () => {
        return (
            <React.Fragment>
                <CssBaseline />
                <Container maxWidth="lg">
                    <TextField
                        autoFocus={true}
                        id="outlined-multiline-static"
                        label={i18n.get("leaseWizard.step.7")}
                        multiline
                        rows="4"
                        variant="outlined"
                        value={this.state.notes}
                        onChange={e => { this.setState({ notes: e.target.value }) }}
                    />
                </Container>
            </React.Fragment>
        )
    }

    render() {
        return (
            <Dialog
                maxWidth={"lg"}
                fullWidth={true}
                open={this.props.open}
                keepMounted
                disableBackdropClick={true}
                onClose={this.onClose}
                fullScreen={false}
            >

                <DialogTitle>
                    <React.Fragment>
                        {i18n.get("leaseWizard.title")}
                        <Stepper activeStep={this.state.activeStep}>
                            {this.state.steps.map(label => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </React.Fragment>
                </DialogTitle>
                <DialogContent>
                    {this.getStepContent(this.state.activeStep)}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose} color="primary">
                        {i18n.get("leaseWizard.cancel")}
                    </Button>
                    {this.state.activeStep > 0 &&
                        <Button onClick={this.onPrevious} color="primary">
                            {i18n.get("leaseWizard.previous")}
                        </Button>
                    }
                    {this.state.activeStep >= 0 && this.state.activeStep < (this.state.steps.length - 1) &&
                        <Button onClick={this.onNext} color="primary" disabled={!this.nextPossible()}>
                            {i18n.get("leaseWizard.next")}
                        </Button>
                    }
                    {this.state.activeStep === (this.state.steps.length - 1) &&
                        <Button onClick={this.onSave} color="primary">
                            {i18n.get("leaseWizard.save")}
                        </Button>
                    }
                </DialogActions>

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </Dialog>
        );
    }
}

LeaseWizard.propTypes = {
    classes:
        PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(LeaseWizard)
